(function () {
  const POPUP_FORM_IDS = ["443326", "530339"];

  const body = document.querySelector('body');
  const popupSelectOption = body.dataset.popupSelectOption;

  // function makeFullFormAppear() {
  //   localStorage.removeItem(`${POPUP_FORM_ID}-dismissed-after-submit`);
  //   localStorage.removeItem(`${POPUP_FORM_ID}-dismissed-in-session`);
  //   localStorage.removeItem(`${POPUP_FORM_ID}-minimized-in-session`);
  // }

  function removeForm() {
    const sessionId = localStorage.getItem('forms_fallback_session_id') ||
      localStorage.getItem('forms_previous_session_id') ||
      POPUP_FORM_IDS[0];

    POPUP_FORM_IDS.forEach(id => {
      localStorage.setItem(`${id}-dismissed-after-submit`, sessionId);
      localStorage.setItem(`${id}-dismissed-in-session`, sessionId);
      localStorage.setItem(`${id}-minimized-in-session`, sessionId);
    });
  }

  function makeMinimizedFormAppear() {
    POPUP_FORM_IDS.forEach(id => {
      localStorage.removeItem(`${id}-dismissed-after-submit`);
      localStorage.removeItem(`${id}-dismissed-in-session`);
    });
  }

  if (popupSelectOption && popupSelectOption == "Collezionista") {
    console.log("Popup: Collezionista");
    removeForm();
  } else if (popupSelectOption && popupSelectOption == "Curioso") {
    console.log("Popup: Curioso");
    makeMinimizedFormAppear();
  } else {
    console.log("Popup: Dato non presente");
    makeMinimizedFormAppear();
  }

  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const [url, options] = args;



    if (url && url.includes('forms.shopifyapps.com/api/v2/form_submission')) {
      console.log('Form submission API call detected');

      const collectorOrCurious = JSON.parse(args[1].body)['custom#scegli_unopzione'];

      if (collectorOrCurious == "Collezionista") {

        return originalFetch.apply(this, args)
          .then(response => {
            if (response.ok) {
              console.log('Form submitted successfully via API');
              setTimeout(() => {
                // redirect to account login page
                // window.location.href = '/customer_authentication/login?return_to=%2F';
                // refresh the page
                window.location.reload();
              }, 1500);
            }
            return response;
          });

      } else {
        return originalFetch.apply(this, args);
      }
    }

    return originalFetch.apply(this, args);
  };
})();

document.addEventListener('DOMContentLoaded', function () {
  const POPUP_FORM_IDS = ["443326", "530339"];
  const styleSheetRules = [
    `
        input, button[aria-expanded], textarea {
            border-radius: 0 !important;
        }
    `,
    `
        div[class*="_formFileInput"] button[type="button"] {
            border: 1px dashed #4E7AB0 !important;
            border-radius: 0 !important;
        }
    `,
    `
        fieldset > div {
            grid-template-columns: 1fr 1fr !important;
            margin-bottom: .5rem;
        }
    `,
    `
        button[type="submit"] {
            background: #9B7960 !important;
            color: #fff !important;
            border-radius: 0 !important;
            letter-spacing: var(--button-letter-spacing);
            font: var(--button-font);
            text-transform: uppercase !important;
        }
    `
  ];

  POPUP_FORM_IDS.forEach(id => {

    const popupFormObserver = new MutationObserver((mutationsList, observer) => {

      const popupForm = document.querySelector(`#app-embed-container-${id}`);

      if (popupForm) {
        observer.disconnect();
        const shadow = popupForm.shadowRoot;
        if (!shadow) return console.warn('Shadow root non disponibile.');
        const sheet = new CSSStyleSheet();
        styleSheetRules.forEach(rule => {
          sheet.insertRule(rule);
        });
        shadow.adoptedStyleSheets.push(sheet);
      }
    });

    popupFormObserver.observe(document.body, { childList: true, subtree: true });
  });


});